angular.module('unica_tools.tools_controllers', [])

.controller('ToolsBasicController',
	function(
		$rootScope, $scope
	) {

	$scope.forms = {};

	// $scope.dp_open = false;

	// $scope.openDatepicker = function() {
	// 	$scope.dp_open = true;
	// };


});